import { Injectable } from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormGroupService {

  constructor() { }

  public markFormAsTouched(form: FormGroup, opts?: {
		onlySelf?: boolean;
	}) {
  	Object.keys(form.controls).forEach(kControl => {
  		const control = form.controls[kControl] as AbstractControl;
  		control.markAsTouched(opts);
		});
	}

	public markFormAsUntouched(form: FormGroup, opts?: {
		onlySelf?: boolean;
	}) {
		Object.keys(form.controls).forEach(kControl => {
			const control = form.controls[kControl] as AbstractControl;
			control.markAsUntouched(opts);
		});
	}

	public markFormAsPristine(form: FormGroup, opts?: {
		onlySelf?: boolean;
	}) {
		Object.keys(form.controls).forEach(kControl => {
			const control = form.controls[kControl] as AbstractControl;
			control.markAsPristine(opts);
		});
	}
}
